import { useState, useCallback, useEffect } from 'react';
import { Box } from '@mui/material';
import { getAllCommissionProgress } from '../../api/commissionProgressApi';
import GeneralCommissionProgressList from '../common/commission/generalCommissionProgressList';
import EditSalesCommissionModal from './editSalesCommissionModal';
import IncentiveClaimsList from './incentiveClaimsList';

const COMM_FILTERS = ['All', 'PSC', 'DOC', 'TOC', 'MOC', 'Incentives'];

const SALES_COMM_COLUMNS = [
    'salesId', 'depositDate', 'customer', 'agent', 'coAgent',
    'commissionType', 'paymentTo', 'commission', 'progress', 'status',
    'productCategory', 'productEnergy',
    'oriPrice', 'asternDiscount', 'agentDiscount', 'finalPrice',
    'firstPayment', 'firstPaymentDate', 'secondPayment', 'secondPaymentDate',
    'repayment',
    'actions',
];

export default function SalesCommissionList() {
    const [allData, setAllData] = useState([]);
    const [activeFilter, setActiveFilter] = useState('All');
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedCommission, setSelectedCommission] = useState(null);
    const [showArchived, setShowArchived] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const response = await getAllCommissionProgress(showArchived);
            setAllData(response.data);
        } catch (error) {
            console.error('Error fetching commission data:', error);
        }
    }, [showArchived]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const isIncentives = activeFilter === 'Incentives';

    const filteredData = activeFilter === 'All'
        ? allData
        : allData.filter(item => {
            const t = item.commissionProgressDto?.commPayType || '';
            return t === activeFilter || t.startsWith(activeFilter + '/');
          });

    const handleRowClick = (commission) => () => {
        setSelectedCommission(commission);
        setShowEditModal(true);
    };

    return (
        <div>
            <Box sx={{ mb: 2 }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>All Sales Commissions</h2>
                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>View all commission progress records</p>
            </Box>

            {/* Filter Buttons */}
            <Box sx={{ display: 'flex', gap: 1, mb: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                {COMM_FILTERS.map(filter => (
                    <button
                        key={filter}
                        onClick={() => setActiveFilter(filter)}
                        style={{
                            border: activeFilter === filter ? '1px solid #1A8CFF' : '1px solid #E2E8F0',
                            background: activeFilter === filter ? 'linear-gradient(135deg, #1A8CFF, #0F62CC)' : 'white',
                            color: activeFilter === filter ? 'white' : '#475569',
                            borderRadius: '8px',
                            padding: '6px 16px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                            fontFamily: "'Poppins', sans-serif",
                            transition: 'all 0.15s ease',
                        }}
                    >
                        {filter}
                    </button>
                ))}
                {!isIncentives && (
                    <Box sx={{ ml: 2, display: 'flex', borderRadius: '8px', overflow: 'hidden', border: '1px solid #E2E8F0' }}>
                        <button onClick={() => setShowArchived(false)} style={{ padding: '6px 16px', fontSize: '0.78rem', fontWeight: 600, fontFamily: "'Poppins', sans-serif", border: 'none', cursor: 'pointer', background: !showArchived ? '#1A8CFF' : '#fff', color: !showArchived ? '#fff' : '#64748B' }}>
                            Active
                        </button>
                        <button onClick={() => setShowArchived(true)} style={{ padding: '6px 16px', fontSize: '0.78rem', fontWeight: 600, fontFamily: "'Poppins', sans-serif", border: 'none', borderLeft: '1px solid #E2E8F0', cursor: 'pointer', background: showArchived ? '#EF4444' : '#fff', color: showArchived ? '#fff' : '#64748B' }}>
                            Archived
                        </button>
                    </Box>
                )}
            </Box>

            {isIncentives ? (
                <IncentiveClaimsList />
            ) : (
                <GeneralCommissionProgressList
                    fetchData={filteredData}
                    onRowClick={handleRowClick}
                    visibleColumns={SALES_COMM_COLUMNS}
                />
            )}

            <EditSalesCommissionModal
                show={showEditModal}
                onHide={() => { setShowEditModal(false); setSelectedCommission(null); }}
                selectedCommission={selectedCommission}
                onSaved={() => { setShowEditModal(false); setSelectedCommission(null); fetchData(); }}
            />
        </div>
    );
}
